import { render, staticRenderFns } from "./card.component.vue?vue&type=template&id=33160d2b&scoped=true&lang=pug"
import script from "./card.component.vue?vue&type=script&lang=ts"
export * from "./card.component.vue?vue&type=script&lang=ts"
import style0 from "./card.component.vue?vue&type=style&index=0&id=33160d2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33160d2b",
  null
  
)

export default component.exports